import {RoomBaseApiService} from "@/core/service/room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";

export class RoomURLShareService extends RoomBaseApiService {
    async createURLShare(params) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/urlshare`,
                { urlTitle : params.urlTitle, urlPath: params.urlPath });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async removeURLShare(params) {
        try {
            const response = await this.request().delete(`/api/v3/room/${this.getRoomId()}/urlshare/${params.urlIdx}`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async updateURLShare(params) {
        try {
            const response = await this.request().patch(
                `/api/v3/room/${this.getRoomId()}/urlshare/${params.urlIdx}`,
                { ...params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async getURLShareList() {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/urlshare`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async startURLShareList(params) {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/urlshare/${params.urlIdx}`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }
}

export const roomURLShareService = new RoomURLShareService();